import { Box } from "@mui/material"
import Sidebar from "../components/sidebar/Sidebar"
import Navbar from "../components/navbar/Navbar"
import { Outlet } from "react-router-dom"
import { useState } from "react";

function MainLayout() {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    return (
        <>
            <Box sx={{display:"flex"}} width='100%' height='90%'>
                <Sidebar 
                    drawerWidth={ "100px"}
                    isSidebarOpen={isSidebarOpen}
                    setIsSidebarOpen={setIsSidebarOpen}

                />
                <Box flexGrow={1} width='90%'>
                    <Navbar
                     drawerWidth={ "100px"}
                        isSidebarOpen={isSidebarOpen}
                        setIsSidebarOpen={setIsSidebarOpen}
                    />
                    <Outlet />
                </Box>
            </Box></>
    )
}
export default MainLayout